<template>
  <w-icon-wrapper
    width="27" 
    height="24" 
    viewBox="0 0 27 24" 
    fill="none"
    icon-name='work-options-icon'
  >
    <g
      id='_10_Options_Icon'
      data-name='10 Options_Icon'
      transform='translate(-8.687)'
    >
      <g
        id='Ellipse_1510'
        data-name='Ellipse 1510'
        fill='none'
        stroke='currentColor'
        stroke-miterlimit='10'
        stroke-width='2'
        transform='translate(8.687)'
      >
        <circle
          cx='3.5'
          cy='3.5'
          r='3.5'
          stroke='none'
        />
        <circle
          cx='3.5'
          cy='3.5'
          fill='none'
          r='2.5'
        />
      </g>
      <g
        id='Ellipse_1511'
        data-name='Ellipse 1511'
        fill='none'
        stroke='currentColor'
        stroke-miterlimit='10'
        stroke-width='2'
        transform='translate(8.687 8.375)'
      >
        <circle
          cx='3.5'
          cy='3.5'
          r='3.5'
          stroke='none'
        />
        <circle
          cx='3.5'
          cy='3.5'
          fill='none'
          r='2.5'
        />
      </g>
      <g
        id='Ellipse_1512'
        data-name='Ellipse 1512'
        fill='none'
        stroke='currentColor'
        stroke-miterlimit='10'
        stroke-width='2'
        transform='translate(8.687 17)'
      >
        <circle
          cx='3.5'
          cy='3.5'
          r='3.5'
          stroke='none'
        />
        <circle
          cx='3.5'
          cy='3.5'
          fill='none'
          r='2.5'
        />
      </g>
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconOptions' };
</script>
